import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';
import TextFormField from 'CommonComponents/TextFormField';

import { useConfirmationModal } from 'Hooks/useConfirmationModal';

const EmailReportModal = ({ modal, onClose, onSend, loading }) => {
    const close = () => {
        onClose();
        modal.hide();
    };

    return (
        <Modal modal={modal} id="email-report-modal">
            <ModalHeader title={$t('Email Report')} close={close}></ModalHeader>

            <div className="tw-rounded-b">{loading ? <LoadingSpinner /> : <EmailReportForm onClose={close} onSend={onSend} loading={loading} />}</div>
        </Modal>
    );
};

const EmailReportSchema = Yup.object().shape({
    email: Yup.string().email($t('Invalid email')).required($t('This value is required')),
});

function EmailReportForm({ onClose, onSend, loading }) {
    const confirm = useConfirmationModal();

    return (
        <div>
            <Formik
                enableReinitialize
                validationSchema={EmailReportSchema}
                initialValues={{ email: '' }}
                onSubmit={(values, { setSubmitting }) => {
                    const email = values.email;

                    confirm({
                        message: $t('Are you sure you want to send the report to this email address?'),
                        onConfirm: () => onSend(email),
                    });

                    setSubmitting(false);
                }}
            >
                {({ handleSubmit, isSubmitting }) => (
                    <div className="tw-space-y-4">
                        <TextFormField name="email" label={$t('Email')} required={true} placeholder={$t('e.g. user@example.com')} disabled={isSubmitting} />
                        <ModalFooter
                            allowCancel
                            allowSubmit
                            onCancel={onClose}
                            handleSubmit={handleSubmit}
                            isSubmitting={loading}
                            primaryButtonText={$t('Send')}
                            cancelButtonText={$t('Cancel')}
                        />
                    </div>
                )}
            </Formik>
        </div>
    );
}

export default EmailReportModal;
